'use client';

import { lazy, Suspense } from 'react';

import { useCustomerInformation } from '../../../../hooks/useCustomerInformation/useCustomerInformation';
import { LoginDialogComposed } from '../../../../Login/LoginDialogComposed/LoginDialogComposed';
import { useAccountLink } from '../../shared/useAccountLink';
import { Slot, type SlotProps } from '../Base/Slot.client';

const AccountPopoverContent = lazy(
  () => import(/* webpackChunkName: 'AccountPopoverContent' */ '../Base/AccountPopoverContent'),
);

export type AccountSlotProps = Pick<SlotProps, 'priority'>;

/** My account slot */
export const AccountSlot = (props: AccountSlotProps) => {
  const { customerInformation } = useCustomerInformation();
  const { href, label } = useAccountLink();

  return (
    <>
      <div className="hidden md:block">
        <LoginDialogComposed>
          {(openLoginDialog) => (
            <Slot
              {...props}
              useRouterLink={false}
              href={href}
              icon={<span className="icon-emp-user size-4" />}
              title={label}
              badgeCount={customerInformation?.newsCount ?? undefined}
            >
              <Suspense>
                <AccountPopoverContent onLogin={openLoginDialog} />
              </Suspense>
            </Slot>
          )}
        </LoginDialogComposed>
      </div>
      <div className="md:hidden">
        <Slot
          {...props}
          useRouterLink={false}
          href={href}
          icon={<span className="icon-emp-user size-4" />}
          badgeCount={customerInformation?.newsCount ?? undefined}
          linkAriaLabel={label}
        />
      </div>
    </>
  );
};
